import CustomChartTooltip from "./CustomChartTooltip";

export default CustomChartTooltip;
